import { useState } from "react";
import Setup from "../Setup/Setup";
import List from "../List/List";
import Teams from "../Teams/Teams";

import { useInterval } from "../hooks/useInterval";

import styles from "./App.module.css";

const App = () => {
  const [list, setList] = useState([]);
  const [teams, setTeams] = useState([]);
  const [numberOfTeams, setNumberOfTeams] = useState(null);
  const [showSetup, setShowSetup] = useState(true);
  const [done, setDone] = useState(false);
  const [drawIndex, setDrawIndex] = useState(0);
  const [intervalDuration, setIntervalDuration] = useState(null);

  useInterval(() => {
    if (list.length) {
      handleDrawOne();
    } else {
      setIntervalDuration(null);
    }
  }, intervalDuration);

  const handleDrawAll = () => {
    setIntervalDuration(300);
  };

  const handleDrawOne = () => {
    const min = 0;
    const max = Math.floor(list.length);
    const random = Math.floor(Math.random() * (max - min) + min);

    let randomItem = list.splice(random, 1);

    setTeams([...teams], teams[drawIndex].push(randomItem[0]));

    if (drawIndex === numberOfTeams - 1) {
      setDrawIndex(0);
    } else {
      setDrawIndex(drawIndex + 1);
    }

    if (list.length === 0) {
      setDone(true);
    }
  };

  return (
    <div className={styles.app}>
      <div className={styles.inner}>
        <div className={styles.side}>
          {showSetup && (
            <Setup
              list={list}
              setList={setList}
              setTeams={setTeams}
              setShowSetup={setShowSetup}
              setNumberOfTeams={setNumberOfTeams}
            />
          )}
          {!showSetup && (
            <>
              <button
                className={styles.draw}
                disabled={done}
                onClick={handleDrawOne}
              >
                Draw one
              </button>
              <button
                onClick={handleDrawAll}
                className={styles.draw}
                disabled={done}
              >
                Draw all
              </button>
              <List items={list} />
            </>
          )}
        </div>
        <div className={styles.listView}>
          {showSetup && <List items={list} />}
          <Teams teams={teams} />
        </div>
      </div>
    </div>
  );
};

export default App;
